import { _ as _define_property } from "@swc/helpers/_/_define_property";
export class TimeActivitiesModel {
    static fromDTO(dto) {
        const services = {};
        dto.forEach((item)=>{
            services[item.serviceId] = item.timeActivities;
        });
        return new TimeActivitiesModel(services);
    }
    getServices() {
        return this.services;
    }
    getTimeActivitiesForService(serviceId) {
        return this.services[serviceId || ''] || [];
    }
    hasServices() {
        return Object.keys(this.services).length > 0;
    }
    constructor(services = {}){
        _define_property(this, "services", void 0);
        this.services = services;
    }
}
